/** Нормализация для атрибута tel: (российские номера и прочие цифровые последовательности). */
export function telHref(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (!digits) {
    return '#';
  }
  if (digits.startsWith('7') && digits.length === 11) {
    return `tel:+${digits}`;
  }
  if (digits.startsWith('8') && digits.length === 11) {
    return `tel:+7${digits.slice(1)}`;
  }
  return `tel:+${digits}`;
}

/** Форматирование телефона для отображения: `7901000060` → `+7 (901) 000-00-60`. */
export function formatPhone(phone: string): string {
  let digits = phone.replace(/\D/g, '');
  if (!digits) return phone;
  if (digits.startsWith('8') && digits.length === 11) {
    digits = `7${digits.slice(1)}`;
  }
  if (digits.startsWith('7') && digits.length === 11) {
    return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
  }
  if (digits.length === 10) {
    return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
  }
  return phone;
}
